import { formatNumber } from 'utils/formatter';
import { convertNumber, getToday } from 'utils/date';
import AvatarIcon, { avatarIcon } from 'components/features/utils/AvatarIcon';
import React, { ComponentProps } from 'react';
import { TimeOverComment } from './TimeOverComment';
import { AchievedComment } from './AchievedComment';
import { TitleComment } from './TitleComment';
import { YieldComment } from './YieldComment';

export const YearlyAICheer = ({
  percentage,
  title,
  achieved,
  currentAmount,
  targetAmount,
  targetStartDate,
  targetEndDate,
  requiredYield,
  goHowToIncreaseAccumulationAmount,
}: {
  percentage: number;
  title: string;
  achieved: boolean;
  currentAmount: number;
  targetAmount: number;
  targetStartDate: Date;
  targetEndDate: Date;
  requiredYield: number | null;
  goHowToIncreaseAccumulationAmount: () => void;
}): React.ReactElement => {
  const timeOver = convertNumber(targetEndDate) < convertNumber(getToday());
  const advice: {
    icon: ComponentProps<typeof AvatarIcon>['icon'];
    comment: string;
  } = (() => {
    if (percentage < 20) {
      return {
        icon: 'veryBad' as avatarIcon,
        comment: `今年の目標達成率は${
          percentage < 0 ? 0 : formatNumber(percentage, {})
        }％です。無理せず進めていきましょう。`,
      };
    }
    if (percentage < 40) {
      return {
        icon: 'bad' as avatarIcon,
        comment: `今年の目標達成率は${formatNumber(
          percentage,
          {}
        )}％です。その調子です！`,
      };
    }
    if (percentage < 70) {
      return {
        icon: 'average' as avatarIcon,
        comment: `今年の目標達成率は${formatNumber(
          percentage,
          {}
        )}％です。目標達成に向けて着実に続けられているようですね。`,
      };
    }
    if (percentage < 90) {
      return {
        icon: 'good' as avatarIcon,
        comment: `今年の目標達成率は${formatNumber(
          percentage,
          {}
        )}％です。順調ですね。`,
      };
    }
    if (percentage < 100) {
      return {
        icon: 'good' as avatarIcon,
        comment: `今年の目標達成率は${formatNumber(
          percentage,
          {}
        )}％です。目標達成まであと一息です。`,
      };
    }
    return {
      icon: 'veryGood' as avatarIcon,
      comment: '今年の目標を達成しました。お疲れ様でした。',
    };
  })();

  return (
    <>
      {achieved ? (
        <AchievedComment title={title} />
      ) : (
        <>
          {timeOver ? (
            <TimeOverComment icon={advice.icon} />
          ) : (
            <>
              <div className="w-full flex flex-col">
                <div className="flex flex-row">
                  <AvatarIcon icon={advice.icon} />
                  <TitleComment
                    className={'ml-4'}
                    targetEndDate={targetEndDate}
                    targetStartDate={targetStartDate}
                    currentAmount={currentAmount}
                    targetAmount={targetAmount}
                  />
                </div>
                <div className="flex flex-col">
                  <div className="mt-2 text-bluegray-700 text-sm">
                    {advice.comment}
                  </div>
                  <YieldComment
                    className={'mt-2'}
                    title={title}
                    requiredYield={requiredYield}
                    goHowToIncreaseAccumulationAmount={
                      goHowToIncreaseAccumulationAmount
                    }
                  />
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};
